import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'
import ProductCard from './productCard'
import category from '../utils/categoryData'

const ProductList = ({ slice }) => {
  const data = useStaticQuery(graphql`
    {
      prismicConfig {
        _previewable
        data {
          no_products {
            richText
            text
          }
        }
      }
      allAlgolia {
        edges {
          node {
            auctionUuid
            categoryUuid
            countryCode
            image {
              basePath
              label
              size
              uuid
              versionAndPublicId
            }
            objectID
            summary
            title
          }
        }
      }
    }
  `)

  // Get array of items that match the categories
  const noProducts = data.prismicConfig.data.no_products
  const filterCategories = Object.keys(category).filter((id) => category[id].parent === slice.primary.category)
  const categoryItems = data.allAlgolia.edges.filter((item) => {
    item = item.node
    return filterCategories.includes(item.categoryUuid)
  })

  // Filtering
  const [selectedOption, setSelectedOption] = useState('All')
  const [searchQuery, setSearchQuery] = useState('')
  const [filteredItems, setFilteredItems] = useState(categoryItems)

  const itemsToShow = 96
  const [visibleItemCount, setVisibleItemCount] = useState(itemsToShow)

  const handleShowMore = () => {
    setVisibleItemCount((prevCount) => prevCount + itemsToShow)
  }

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase()
    setSearchQuery(query)

    const filtered = categoryItems.filter((item) => {
      return item.node.title.toLowerCase().includes(query) && (selectedOption === 'All' || item.node.countryCode === selectedOption)
    })

    setFilteredItems(filtered)
  }

  const handleCountryChange = (event) => {
    const countryCode = event.target.value

    setSelectedOption(countryCode)

    const filtered = categoryItems.filter((item) => {
      return (searchQuery === '' || item.node.title.toLowerCase().includes(searchQuery)) && (countryCode === 'All' || item.node.countryCode === countryCode)
    })

    setFilteredItems(filtered)
  }

  // Get unique country codes
  const countryCodes = Array.from(new Set(categoryItems.map((item) => item.node.countryCode).filter((countryCode) => countryCode !== null && countryCode !== undefined)))

  return (
    <section className='component-productlist mx-auto max-w-screen-xl p-6'>
      {slice.primary.list_title && (
        <div className='prose prose-lg max-w-none'>
          <PrismicRichText field={slice.primary.list_title.richText} />
        </div>
      )}
      {categoryItems.length > 0 && (
        <div className='bg-white shadow rounded-md my-6 md:my-10'>
          <div className='bg-slate-200 rounded-t-md border-b px-6 py-2 flex justify-between items-center'>
            <h3>Filtering</h3>
            <div className='text-xs col-span-4'>
              (Showing {filteredItems.slice(0, visibleItemCount).length} of {filteredItems.length} items)
            </div>
          </div>
          <form className='grid grid-cols-4 gap-4 p-6'>
            <fieldset className='col-span-2 md:col-span-3 flex gap-2 items-center mb-4 w-full'>
              <legend className='border-none m-0 block text-base text-gray-900'>Search</legend>
              <input type='text' placeholder='Search by title' value={searchQuery} onChange={handleSearch} className='w-full px-4 py-2 border border-gray-300 rounded' />
            </fieldset>
            <fieldset className='col-span-2 md:col-span-1 flex gap-2 items-center mb-4 w-full md:w-auto'>
              <legend className='border-none m-0 block text-base text-gray-900'>Country</legend>
              <select className='w-full px-4 py-2 border border-gray-300 rounded' value={selectedOption} onChange={handleCountryChange}>
                <option value='All'>All Countries</option>
                {countryCodes.map((countryCode) => {
                  let countryName = new Intl.DisplayNames(['en'], { type: 'region' })
                  return (
                    <option key={countryCode} value={countryCode}>
                      {countryName.of(countryCode)}
                    </option>
                  )
                })}
              </select>
            </fieldset>
          </form>
        </div>
      )}
      {filteredItems.length > 0 ? (
        <div>
          <ul className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
            {filteredItems.slice(0, visibleItemCount).map((item) => {
              item = item.node
              return (
                <li key={item.objectID} className={item.countryCode}>
                  <ProductCard name={item.title} key={item.objectID} hit={item} auctionUuid={item.auctionUuid} />
                </li>
              )
            })}
          </ul>
          {filteredItems.length > visibleItemCount && (
            <div className='text-center mt-5'>
              <button onClick={handleShowMore} className='button button-brand'>
                Show More
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className='min-w-full mt-6 prose prose-lg'>
          <PrismicRichText field={noProducts.richText} />
        </div>
      )}
    </section>
  )
}

export default ProductList
